import React from 'react';
import { useNavigate } from '@tanstack/react-router';

import type { Timeline } from '../../types/timeline';

import '@awesome.me/webawesome/dist/components/button-group/button-group.js';

const MemoryButtons: React.FC<{ timeline: Timeline; page: string }> = ({ timeline, page }) => {
  const nav = useNavigate();

  return (
    <div className="memory-buttons">
      <div className="wa-cluster">
        <div>
          <wa-button-group>
            <wa-button appearance={page === 'view' ? 'accent' : 'outlined'} onClick={() => nav({ to: `/timelines/${timeline.id}` })}>
              <div className="wa-cluster wa-gap-xs">
                <i className="fa-light fa-eye" />
                View
              </div>
            </wa-button>
            <wa-button appearance={page === 'edit' ? 'accent' : 'outlined'} onClick={() => nav({ to: `/timelines/${timeline.id}/edit` })}>
              <div className="wa-cluster wa-gap-xs">
                <i className="fa-light fa-edit" />
                Edit
              </div>
            </wa-button>
          </wa-button-group>
        </div>
        <div>
          <wa-button appearance="outlined" pill size="xs" href={timeline.url} target="_blank">
            <div className="wa-cluster wa-gap-xs">
              <i className="fa-light fa-eye" />
              Recipient view
            </div>
          </wa-button>
        </div>
      </div>
    </div>
  );
}

export default MemoryButtons;
